<template>
  <div>
    <el-collapse
        v-model="activeCollapseName"
        class="productdetail-collapse"
        @change="collapseChange">
      <el-row :gutter="40">
        <el-collapse-item
            id="bundleInfo"
            :title="title"
            name="bundleInfo">
          <el-row
              :gutter="20"
              class="bundle-info">
            <el-col :span="12">
              <BaseTableDetail
                  :table-set-list="bundleInfo1"
                  :display-item="bundleData"
                  :editable="skuEditable"
                  :is-copied-all="isCopiedAll"
                  :highlight-path-list="highlightPathList"
                  :mode="mode"
                  validate-scope="bundleInfo" />
            </el-col>
            <el-col :span="12">
              <BaseTableDetail
                  :table-set-list="bundleInfo2"
                  :display-item="bundleData"
                  :editable="skuEditable"
                  :is-copied-all="isCopiedAll"
                  :highlight-path-list="highlightPathList"
                  :mode="mode"
                  validate-scope="bundleInfo" />
            </el-col>
          </el-row>
        </el-collapse-item>
      </el-row>
      <el-row :gutter="40">
        <el-card class="bundle-card">
          <el-row>
            <div>
              構成品
              <span class="table-header-btns">
                <el-button v-if="showComponentEdit"
                    size="small"
                    @click="onAddComponent">
                  追加
                </el-button>
              </span>
            </div>
          </el-row>
          <el-row>
            <BaseTableList
                :table-set-list="_tableSetList"
                :display-items="bundleComponentDataFilter()"
                :editable="componentListEditable"
                :mode="mode"
                class="row-clickable-table"
                validate-scope="bundleInfo"
                @row-click="onRowClick">
              <!-- オペレーションボタン -->
              <template
                  slot="operation"
                  slot-scope="{ row }">
                <BaseOperationTooltip
                    v-if="showComponentEdit"
                    :list="getTooltipList(row.row)"
                    placement="bottom-end" />
              </template>
            </BaseTableList>
          </el-row>
        </el-card>
      </el-row>
    </el-collapse>
    <BaseDialog
        title="構成品明細"
        :visible.sync="componentItemDialogVisible"
        :show-only-close-button="true"
        @closed="componentItemDialogClose">
      <template slot="contents">
        <BaseTableDetail
            class="table component-item-table"
            :table-set-list="componentDialogTableSetList"
            :display-item="componentDialogData" />
      </template>
    </BaseDialog>
    <BaseDialog
        title="商品検索"
        append-to-body
        width="90%"
        :visible.sync="searchSkusDialogVisible"
        :show-footer="false">
      <template slot="contents">
        <SearchSkus
            :sku-code="''"
            :table-set-list="skuSearchTableSetList"
            :search-mode="searchBundleMode"
            @sku-selected="skuSelected">
          <template slot="slots"
              slot-scope="{ row }">
            <template v-if="showDetailBtn(row)">
              <div>
                <el-button size="mini"
                    @click="onDetailBtnClick(row.row)">
                  詳細
                </el-button>
              </div>
            </template>
          </template>
        </SearchSkus>
      </template>
    </BaseDialog>
  </div>
</template>

<style scoped>
.el-form-item {
  margin: 0;
}

.el-row {
  margin-bottom: 20px;
}

.el-row.color-size-area {
  padding: 10px 0;
  overflow: hidden;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.05);
}

.el-card {
  color: #181d62;
  font-size: 16px;
  font-weight: bold;
}

.table-header-btns {
    float: right;
}

.component-item-table ::v-deep table th {
  border-bottom: initial;
  width: 130px;
}

</style>

<script>
import _ from 'lodash'
import { mapState, mapGetters, mapActions } from 'vuex'
import common from '@/utils/common'
import * as define from '@/define'
import utilProduct from '@/utils/product'

import BaseTableList from '@/components/molecules/BaseTableList'
import BaseTableDetail from '@/components/molecules/BaseTableDetail'
import BaseOperationTooltip from '@/components/molecules/BaseOperationTooltip'
import { ELEMENT_TYPE } from '@/components/molecules/BaseCell'
import BaseDialog from '@/components/molecules/BaseDialog'
import SearchSkus from '@/components/pages/order/SearchSkus'

const EDITABLE = Object.freeze({
  [define.MODE.NEW]: Object.freeze({
    code: true, name: true, jan: true, skuType: true, makerSku: true, ean: true,
    preparingShipmentStartedAt: true, releaseDatetime: true, suggestedRetailPriceExTax: true, suggestedRetailPriceInTax: true,
    costExTax: true, priceExTax: true, priceInTax: true, salesPeriod: true, onlineDatetime: true,
    productDescription: true, productDetail: true, offlineDatetime: true, isSearchable: true, isSearchableIfUnavailable: true,
    attribute: true
  }),
  [define.MODE.EDIT]: Object.freeze({
    code: false, name: true, jan: true, skuType: true, makerSku: true, ean: true,
    preparingShipmentStartedAt: true, releaseDatetime: true, suggestedRetailPriceExTax: true, suggestedRetailPriceInTax: true,
    costExTax: true, priceExTax: true, priceInTax: true, salesPeriod: true, onlineDatetime: true,
    productDescription: true, productDetail: true, offlineDatetime: true, isSearchable: true, isSearchableIfUnavailable: true,
    attribute: true
  })
})

const COMPONENT_EDITABLE = Object.freeze({
  [define.MODE.NEW]: Object.freeze({
    code: false, name: false, qty: true, salesAmountExTax: true, salesAmountInTax: true,
    attribute: true
  }),
  [define.MODE.EDIT]: Object.freeze({
    code: false, name: false, qty: true, salesAmountExTax: true, salesAmountInTax: true,
    attribute: true
  })
})

const customValidationRules = (v) => {
  // 売上金額のバリデーションチェック
  v.$validator.extend('checkSalesAmount', {
    getMessage: () => '売上金額の合計と一致していません。',
    validate: (value, args) => {
      const bundleData = _.get(v, 'product.fkus.0.skus.0')
      if (bundleData[args[0]]) {
        const sumAmount = _.get(bundleData, 'components')
          .filter((comp) => {
            return _.get(comp, 'isActive', 1) === 1
          })
          .reduce((sum, val) => sum + Number(val[args[1]]), 0)

        if (Number(bundleData[args[0]] || 0) !== sumAmount) {
          return false
        }
      }

      return true
    }
  })

  // 文字数のチェック
  v.$validator.extend('maxLengthSpecial', {
    getMessage: (name, args) => `${name}は${args[0]}文字以下である必要ああります。 ※ 全角：2文字扱い`,
    validate: (value, args) => {
      if (common.getLen(value) > Number(args[0])) return false
      return true
    }
  })
}

export default {
  name: 'ProductBundleSet',
  components: {
    BaseTableList,
    BaseTableDetail,
    BaseOperationTooltip,
    BaseDialog,
    SearchSkus
  },
  inject: ['parentValidator'],
  props: {
    product: {
      type: Object,
      default: () => ({})
    },
    mode: {
      type: Number,
      default: define.MODE.NORMAL
    },
    originData: {
      type: Object,
      default: () => ({})
    },
    storePath: {
      type: String,
      required: true
    },
    isBundle: {
      type: Boolean,
      default: false
    },
    isCopiedAll: {
      type: Boolean,
      default: false
    },
    highlightPathList: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      componentItemDialogVisible: false,
      componentDialogData: {},
      activeCollapseName: [],
      searchSkusDialogVisible: false,
      activeTab: null
    }
  },
  computed: {
    ...mapState({
      customizeMaster: (state) => state.Product.customizeMaster
    }),
    ...mapGetters({
      productUneditableItem: 'productUneditableItem',
      skuUneditableItem: 'skuUneditableItem',
      skuNameAbbreviationMaxLength: 'skuNameAbbreviationMaxLength',
      skuCodeMaxLength: 'skuCodeMaxLength',
      skuTypeOptions: 'skuTypeOptions',
      productBundleReleaseDatetimeIsRequired: 'productBundleReleaseDatetimeIsRequired',
      skuTypeEditable: 'skuTypeEditable',
      skuEditableBySkuType: 'skuEditableBySkuType'
    }),
    ...mapGetters('ProductDetail', {
      productDetailProperties: 'productDetailProperties'
    }),
    title () {
      return this.isBundle ? 'バンドル情報' : 'セット情報'
    },
    bundleData () {
      const fkus = this.product.fkus || []
      const skus = (fkus[0] || {}).skus || []
      return (skus[0] || {})
    },
    bundleComponentData () {
      const fkus = this.product.fkus || []
      const skus = (fkus[0] || {}).skus || []
      return ((skus[0] || {}).components || [])
    },
    skuEditable () {
      // 新規、編集モード以外は編集不可で終了
      if (![define.MODE.NEW, define.MODE.EDIT].includes(this.mode)) return {}

      // SKUのIDが未設定の場合は新規モードとして処理を継続
      const mode = this.bundleData.id == null ? define.MODE.NEW : this.mode

      // 現在のモードに応じた編集可否定義を取得
      let returnValue = _.cloneDeep(EDITABLE[mode] || {})

      // 全ての項目を一旦、編集可にする
      if ([define.MODE.NEW, define.MODE.EDIT].includes(mode)) {
        // 表示プロパティを結合
        [].concat(this.bundleInfo1, this.bundleInfo2)
          .forEach((obj, data) => {
            if (_.get(obj, 'properties.0.editableId', null) != null) {
              _.set(returnValue, obj.properties[0].editableId, true)
            }
          })
      }

      // sku種類の編集権限を取得
      const skuEditable = this.skuTypeEditable(this.bundleData.skuType)
      // 編集 かつ SKU種類が編集可能なタイプでないときすべて編集不可にする
      if (mode === define.MODE.EDIT && !skuEditable) {
        Object.keys(returnValue).forEach((key) => {
          _.set(returnValue, [key], false)
        })
        // // 編集不可SKU種類の編集可項目設定にある項目は編集可に更新する
        this.skuEditableBySkuType(this.bundleData.skuType).forEach((key) => {
          _.set(returnValue, key, true)
        })
      }
      // 編集 かつ 既に注文がある場合、サービスサイトで設定されている項目は編集不可にする
      if (mode === define.MODE.EDIT && this.product.isOrdered) {
        this.productUneditableItem.forEach((key) => {
          _.set(returnValue, key, false)
        })
        this.skuUneditableItem.forEach((key) => {
          _.set(returnValue, key, false)
        })
      }

      Object.keys(EDITABLE[mode] || {}).forEach((key) => {
        if (!EDITABLE[mode][key]) _.set(returnValue, key, false)
      })

      return returnValue
    },
    componentListEditable () {
      // 編集 かつ 既に注文がある場合、サービスサイトで設定されている項目は編集不可にする
      return COMPONENT_EDITABLE[this.mode] || {}
    },
    showComponentEdit () {
      return [ define.MODE.EDIT, define.MODE.NEW ].includes(this.mode)
    },
    // カスタマイズ属性の親権限キー
    parentPermissionKey () {
      return define.PermissionKeys.Product.Detail.BundleSet.ATTRIBUTE
    },
    activeTabName: {
      // getter 関数
      get: function () {
        const tabIds = this.skus.map((sku) => `${sku.color.code}-${sku.size.code}`)

        if (tabIds.includes(this.activeTab)) {
          return this.activeTab
        } else {
          // 一番左のタブを表示する。
          return this.skus[0] ? `${this.skus[0].color.code}-${this.skus[0].size.code}` : ''
        }
      },
      // setter 関数
      set: function (val) {
        this.activeTab = val
      }
    },
    bundleInfo1 () {
      let returnValue = this.isBundle
        ? [
          {
            label: 'バンドルコード',
            properties: [ {
              type: 'String', path: 'code', elementType: ELEMENT_TYPE.INPUT,
              editableId: 'code', validateRule: this.skuCodeMaxLength() != null
                ? `required|regex:^[a-zA-Z0-9!-/:-@¥[-\`{-~]*$|max:${this.skuCodeMaxLength() || 0}`
                : `required|regex:^[a-zA-Z0-9!-/:-@¥[-\`{-~]*$|max:50`,
              validateAs: 'バンドルコード',
              funcId: define.PermissionKeys.Product.Detail.BundleSet.SKU_CODE
            }]
          },
          {
            label: '表示名',
            properties: [ {
              type: 'String', path: 'name', elementType: ELEMENT_TYPE.INPUT,
              editableId: 'name',
              funcId: define.PermissionKeys.Product.Detail.BundleSet.NAME
            }]
          },
          {
            label: 'バンドル名（カナ）',
            properties: [ {
              type: 'String', path: 'skuNameKana', elementType: ELEMENT_TYPE.INPUT,
              editableId: 'name',
              funcId: define.PermissionKeys.Product.Detail.BundleSet.NAME_KANA
            }]
          },
          {
            label: 'バンドル名略称',
            properties: [ {
              type: 'String', path: 'skuNameAbbreviation', elementType: ELEMENT_TYPE.INPUT,
              editableId: 'name', validateAs: 'バンドル名略称',
              validateRule: this.skuNameAbbreviationMaxLength() != null
                ? `maxLengthSpecial:${this.skuNameAbbreviationMaxLength() || 0}` : '',
              funcId: define.PermissionKeys.Product.Detail.BundleSet.ABBREVIATION_NAME
            }]
          },
          {
            label: 'JANコード',
            properties: [ {
              type: 'String', elementType: ELEMENT_TYPE.INPUT, path: 'jan',
              editableId: 'jan',
              funcId: define.PermissionKeys.Product.Detail.BundleSet.JAN_CODE
            }]
          },
          {
            label: 'バンドル商品種類',
            properties: [ {
              type: 'String', path: 'skuType', validateRule: 'required',
              validateAs: 'バンドル商品種類',
              elementType: ELEMENT_TYPE.SELECT_BOX, editableId: 'skuType',
              codeName: 'm_product.sku_type',
              selectCode: () => {
                return this.skuTypeOptions.filter((opt) => {
                  return opt.selectable === '1' && opt.displayTarget === '2'
                })
              },
              funcId: define.PermissionKeys.Product.Detail.Sku.SKU_TYPE
            }]
          },
          {
            label: '他社SKUコード',
            properties: [ {
              type: 'String', elementType: ELEMENT_TYPE.INPUT, path: 'makerSku',
              editableId: 'makerSku',
              funcId: define.PermissionKeys.Product.Detail.BundleSet.MAKER_SKU_CODE
            }]
          },
          {
            label: 'EANコード',
            properties: [ {
              type: 'String', elementType: ELEMENT_TYPE.INPUT, path: 'ean',
              editableId: 'ean', codeName: 'm_product.product_type', selectCode: 'm_product.product_type',
              funcId: define.PermissionKeys.Product.Detail.BundleSet.EAN_CODE
            }]
          }]
        : [
          {
            label: 'セットコード',
            properties: [ {
              type: 'String', path: 'code', elementType: ELEMENT_TYPE.INPUT,
              editableId: 'code', validateRule: this.skuCodeMaxLength() != null
                ? `required|regex:^[a-zA-Z0-9!-/:-@¥[-\`{-~]*$|max:${this.skuCodeMaxLength() || 0}`
                : `required|regex:^[a-zA-Z0-9!-/:-@¥[-\`{-~]*$|max:50`,
              validateAs: 'セットコード',
              funcId: define.PermissionKeys.Product.Detail.BundleSet.SKU_CODE
            }]
          },
          {
            label: 'セット商品種類',
            properties: [ {
              type: 'String', path: 'skuType', validateRule: 'required',
              validateAs: 'セット商品種類',
              elementType: ELEMENT_TYPE.SELECT_BOX, editableId: 'skuType',
              codeName: 'm_product.sku_type',
              selectCode: () => {
                return this.skuTypeOptions.filter((opt) => {
                  return opt.selectable === '1' && opt.displayTarget === '3'
                })
              },
              funcId: define.PermissionKeys.Product.Detail.Sku.SKU_TYPE
            }]
          }
        ]

      // バンドルでのみ使用する情報
      if (this.isBundle) {
        returnValue = returnValue.concat([
          {
            label: '希望小売価格(税抜)',
            properties: [ {
              type: 'Number', elementType: ELEMENT_TYPE.INPUT_NUMBER, path: 'suggestedRetailPriceExTax',
              editableId: 'suggestedRetailPriceExTax',
              funcId: define.PermissionKeys.Product.Detail.BundleSet.SUGGESTED_RETAIL_PRICE_EX_TAX
            }]
          },
          {
            label: '希望小売価格(税込)',
            properties: [ {
              type: 'Number', elementType: ELEMENT_TYPE.INPUT_NUMBER, path: 'suggestedRetailPriceInTax',
              editableId: 'suggestedRetailPriceInTax',
              funcId: define.PermissionKeys.Product.Detail.BundleSet.SUGGESTED_RETAIL_PRICE_IN_TAX
            }]
          },
          {
            label: '原価(税抜)',
            properties: [ {
              type: 'Number', elementType: ELEMENT_TYPE.INPUT_NUMBER, path: 'costExTax',
              editableId: 'costExTax',
              funcId: define.PermissionKeys.Product.Detail.BundleSet.COST_EX_TAX
            }]
          },
          {
            label: '価格(税抜)',
            properties: [ {
              type: 'Number', elementType: ELEMENT_TYPE.INPUT_NUMBER, path: 'priceExTax',
              editableId: 'priceExTax', validateRule: 'checkSalesAmount:priceExTax,salesAmountExTax',
              funcId: define.PermissionKeys.Product.Detail.BundleSet.NET_PRICE_EX_TAX
            }]
          },
          {
            label: '価格(税込)',
            properties: [ {
              type: 'Number', elementType: ELEMENT_TYPE.INPUT_NUMBER, path: 'priceInTax',
              editableId: 'priceInTax', validateRule: 'checkSalesAmount:priceInTax,salesAmountInTax',
              funcId: define.PermissionKeys.Product.Detail.BundleSet.NET_PRICE_IN_TAX
            }]
          },
          {
            label: '発売日時',
            properties: [ {
              type: 'Date', elementType: ELEMENT_TYPE.DATE_TIME, path: 'releaseDatetime',
              editableId: 'releaseDatetime',
              validateRule: this.productBundleReleaseDatetimeIsRequired ? 'required' : '', validateAs: '発売日時',
              funcId: define.PermissionKeys.Product.Detail.BundleSet.RELEASE_DATETIME,
              dateFormat: 'YYYY/MM/DD HH:mm:ss'
            }]
          },
          {
            label: '出荷指示送信開始日',
            properties: [ {
              type: 'Date', elementType: ELEMENT_TYPE.DATE_TIME, path: 'preparingShipmentStartedAt',
              editableId: 'preparingShipmentStartedAt',
              funcId: define.PermissionKeys.Product.Detail.BundleSet.PREPARING_SHIPMENT_STARTED_AT,
              dateFormat: 'YYYY/MM/DD HH:mm:ss'
            }]
          }
        ])

        let index = 1
        // カスタマイズ属性を設定
        if (this.customizeMaster != null &&
          this.$isFunctionShown(define.PermissionKeys.Product.Detail.BundleSet.ATTRIBUTE)) {
          this.customizeMaster.filter((element) => {
            // 商品種類共通のカスタマイズ属性である
            // バンドルタブである
            // 表示位置が左の段であること
            return (element.functionKey === define.CUSTOMIZE_PROPERTY_KEY.PRODUCT.BUNDLE.COMMON.LEFT)
          }).sort((a, b) => {
            return a.displayOrder - b.displayOrder
          }).forEach((customizeObj) => {
            let emptyCellNum = customizeObj.displayOrder - index
            while (emptyCellNum > 1) {
              returnValue.push(utilProduct.getCustomizeEmptyColumn())
              emptyCellNum -= 1
            }
            returnValue.push(utilProduct.getCustomizeColumn(this.product.fkus[0].skus[0], customizeObj, 'attributes', 'attribute',
              this.storePath, 'ProductDetail/productDetail/fkus[0]/skus[0]', this.parentPermissionKey))

            index = customizeObj.displayOrder
          })
        }

        index = 1
        // カスタマイズ属性を設定
        if (this.customizeMaster != null &&
          this.$isFunctionShown(define.PermissionKeys.Product.Detail.BundleSet.ATTRIBUTE)) {
          this.customizeMaster.filter((element) => {
            // 対象の商品種類のカスタマイズ属性である
            // バンドルタブである
            // 表示位置が左の段であること
            return (element.functionKey === define.CUSTOMIZE_PROPERTY_KEY.PRODUCT.BUNDLE.PRODUCT_TYPE.LEFT.replace('{productType}', this.product.productType))
          }).sort((a, b) => {
            return a.displayOrder - b.displayOrder
          }).forEach((customizeObj) => {
            let emptyCellNum = customizeObj.displayOrder - index
            while (emptyCellNum > 1) {
              returnValue.push(utilProduct.getCustomizeEmptyColumn())
              emptyCellNum -= 1
            }
            returnValue.push(utilProduct.getCustomizeColumn(this.product.fkus[0].skus[0], customizeObj, 'attributes', 'attribute',
              this.storePath, 'ProductDetail/productDetail/fkus[0]/skus[0]', this.parentPermissionKey))

            index = customizeObj.displayOrder
          })
        }
        index = 1
        // カスタマイズ属性を設定
        if (this.customizeMaster != null &&
          this.$isFunctionShown(define.PermissionKeys.Product.Detail.BundleSet.ATTRIBUTE)) {
          this.customizeMaster.filter((element) => {
            // 対象の商品種類のカスタマイズ属性である
            // バンドルタブである
            // 表示位置が左の段であること
            return (element.functionKey === define.CUSTOMIZE_PROPERTY_KEY.PRODUCT.BUNDLE.SKU_TYPE.LEFT.replace('{skuType}', this.product.fkus[0].skus[0].skuType))
          }).sort((a, b) => {
            return a.displayOrder - b.displayOrder
          }).forEach((customizeObj) => {
            let emptyCellNum = customizeObj.displayOrder - index
            while (emptyCellNum > 1) {
              returnValue.push(utilProduct.getCustomizeEmptyColumn())
              emptyCellNum -= 1
            }
            returnValue.push(utilProduct.getCustomizeColumn(this.product.fkus[0].skus[0], customizeObj, 'attributes', 'attribute',
              this.storePath, 'ProductDetail/productDetail/fkus[0]/skus[0]', this.parentPermissionKey))

            index = customizeObj.displayOrder
          })
        }
      } else {
      // セットの場合
        // 商品種類共通のカスタマイズ属性 & セットタブ & 表示位置：左
        this.setCustomizeProperty(returnValue, define.CUSTOMIZE_PROPERTY_KEY.PRODUCT.SET.COMMON.LEFT)
        // 対象の商品種類のカスタマイズ属性 & セットタブ & 表示位置：左
        this.setCustomizeProperty(returnValue, define.CUSTOMIZE_PROPERTY_KEY.PRODUCT.SET.PRODUCT_TYPE.LEFT, '{productType}', this.product.productType)
        // 対象のSKU種類ｓのカスタマイズ属性 & セットタブ & 表示位置：左
        this.setCustomizeProperty(returnValue, define.CUSTOMIZE_PROPERTY_KEY.PRODUCT.SET.SKU_TYPE.LEFT, '{skuType}', this.product.productType)
      }
      return returnValue
    },
    bundleInfo2 () {
      const returnValue = this.isBundle
        ? [
          {
            label: '販売開始日',
            properties: [ {
              type: 'Date', elementType: ELEMENT_TYPE.DATE, path: 'salesPeriodFrom',
              editableId: 'salesPeriod',
              funcId: define.PermissionKeys.Product.Detail.BundleSet.SALES_PERIOD_FROM,
              dateFormat: 'YYYY/MM/DD'
            }]
          },
          {
            label: '販売終了日',
            properties: [ {
              type: 'Date', elementType: ELEMENT_TYPE.DATE, path: 'salesPeriodTo',
              editableId: 'salesPeriod',
              funcId: define.PermissionKeys.Product.Detail.BundleSet.SALES_PERIOD_TO,
              dateFormat: 'YYYY/MM/DD'
            }]
          },
          {
            label: 'オンラインフラグ',
            properties: [ {
              type: 'String', elementType: ELEMENT_TYPE.CHECK_BOX, path: 'isOnline',
              editableId: 'onlineDatetime',
              funcId: define.PermissionKeys.Product.Detail.BundleSet.ONLINE_DATETIME
            }]
          },
          {
            label: 'オンライン日時',
            properties: [ {
              type: 'Date', elementType: ELEMENT_TYPE.DATE_TIME, path: 'onlineDatetime',
              editableId: 'onlineDatetime',
              funcId: define.PermissionKeys.Product.Detail.BundleSet.ONLINE_DATETIME,
              dateFormat: 'YYYY/MM/DD HH:mm:ss'
            }]
          },
          {
            label: 'オフライン日時',
            properties: [ {
              type: 'Date', elementType: ELEMENT_TYPE.DATE_TIME, path: 'offlineDatetime',
              editableId: 'offlineDatetime',
              funcId: define.PermissionKeys.Product.Detail.BundleSet.OFFLINE_DATETIME,
              dateFormat: 'YYYY/MM/DD HH:mm:ss'
            }]
          },
          {
            label: '商品説明',
            properties: [ {
              type: 'String', path: 'productDescription', elementType: ELEMENT_TYPE.INPUT_TEXT_AREA,
              rows: 4, editableId: 'productDescription',
              class: 'multiLineTextBox', lineBreak: true,
              funcId: define.PermissionKeys.Product.Detail.BundleSet.DESCRIPTION
            },
            {
              id: 'previewBtn',
              type: 'String', elementType: ELEMENT_TYPE.BUTTON, class: 'previewBtn',
              icon: '', size: 'small', label: 'プレビュー',
              path: 'productDescription',
              click: this.htmlClick,
              funcId: define.PermissionKeys.Product.Detail.BundleSet.DESCRIPTION
            }]
          },
          {
            label: '商品詳細',
            properties: [ {
              type: 'String', elementType: ELEMENT_TYPE.INPUT_TEXT_AREA, path: 'productDetail',
              editableId: 'productDetail',
              rows: 4, class: 'multiLineTextBox', lineBreak: true,
              funcId: define.PermissionKeys.Product.Detail.BundleSet.DETAIL
            },
            {
              id: 'previewBtn',
              type: 'String', elementType: ELEMENT_TYPE.BUTTON, class: 'previewBtn',
              icon: '', size: 'small', label: 'プレビュー',
              path: 'productDetail',
              click: this.htmlClick,
              funcId: define.PermissionKeys.Product.Detail.BundleSet.DETAIL
            }]
          },
          {
            label: '検索可否',
            properties: [ {
              type: 'String', elementType: ELEMENT_TYPE.CHECK_BOX, path: 'isSearchable',
              editableId: 'isSearchable',
              funcId: define.PermissionKeys.Product.Detail.BundleSet.IS_SEARCHABLE
            }]
          },
          {
            label: '販売不可時の検索可否',
            properties: [ {
              type: 'String', elementType: ELEMENT_TYPE.CHECK_BOX, path: 'isSearchableIfUnavailable',
              editableId: 'isSearchableIfUnavailable',
              funcId: define.PermissionKeys.Product.Detail.BundleSet.IS_SEARCHABLE_IF_UNAVAILABLE
            }]
          }
        ] : [
          {
            label: '検索可否',
            properties: [ {
              type: 'String', elementType: ELEMENT_TYPE.CHECK_BOX, path: 'isSearchable',
              editableId: 'isSearchable',
              funcId: define.PermissionKeys.Product.Detail.BundleSet.IS_SEARCHABLE
            }]
          },
          {
            label: '販売不可時の検索可否',
            properties: [ {
              type: 'String', elementType: ELEMENT_TYPE.CHECK_BOX, path: 'isSearchableIfUnavailable',
              editableId: 'isSearchableIfUnavailable',
              funcId: define.PermissionKeys.Product.Detail.BundleSet.IS_SEARCHABLE_IF_UNAVAILABLE
            }]
          }
        ]

      if (this.isBundle) {
        let index = 1
        // カスタマイズ属性を設定
        if (this.customizeMaster != null &&
          this.$isFunctionShown(define.PermissionKeys.Product.Detail.BundleSet.ATTRIBUTE)) {
          this.customizeMaster.filter((element) => {
            // 商品種類共通のカスタマイズ属性である
            // バンドルタブである
            // 表示位置が右の段であること
            return (element.functionKey === define.CUSTOMIZE_PROPERTY_KEY.PRODUCT.BUNDLE.COMMON.RIGHT)
          }).sort((a, b) => {
            return a.displayOrder - b.displayOrder
          }).forEach((customizeObj) => {
            let emptyCellNum = customizeObj.displayOrder - index
            while (emptyCellNum > 1) {
              returnValue.push(utilProduct.getCustomizeEmptyColumn())
              emptyCellNum -= 1
            }
            returnValue.push(utilProduct.getCustomizeColumn(this.product.fkus[0].skus[0], customizeObj, 'attributes', 'attribute',
              this.storePath, 'ProductDetail/productDetail/fkus[0]/skus[0]', this.parentPermissionKey))

            index = customizeObj.displayOrder
          })
        }

        index = 1
        // カスタマイズ属性を設定
        if (this.customizeMaster != null &&
          this.$isFunctionShown(define.PermissionKeys.Product.Detail.BundleSet.ATTRIBUTE)) {
          this.customizeMaster.filter((element) => {
            // 対象の商品種類のカスタマイズ属性である
            // バンドルタブである
            // 表示位置が右の段であること
            return (element.functionKey === define.CUSTOMIZE_PROPERTY_KEY.PRODUCT.BUNDLE.PRODUCT_TYPE.RIGHT.replace('{productType}', this.product.productType))
          }).sort((a, b) => {
            return a.displayOrder - b.displayOrder
          }).forEach((customizeObj) => {
            let emptyCellNum = customizeObj.displayOrder - index
            while (emptyCellNum > 1) {
              returnValue.push(utilProduct.getCustomizeEmptyColumn())
              emptyCellNum -= 1
            }
            returnValue.push(utilProduct.getCustomizeColumn(this.product.fkus[0].skus[0], customizeObj, 'attributes', 'attribute',
              this.storePath, 'ProductDetail/productDetail/fkus[0]/skus[0]', this.parentPermissionKey))

            index = customizeObj.displayOrder
          })
        }

        index = 1
        // カスタマイズ属性を設定
        if (this.customizeMaster != null &&
          this.$isFunctionShown(define.PermissionKeys.Product.Detail.BundleSet.ATTRIBUTE)) {
          this.customizeMaster.filter((element) => {
            // 対象の商品種類のカスタマイズ属性である
            // バンドルタブである
            // 表示位置が左の段であること
            return (element.functionKey === define.CUSTOMIZE_PROPERTY_KEY.PRODUCT.BUNDLE.SKU_TYPE.RIGHT.replace('{skuType}', this.product.fkus[0].skus[0].skuType))
          }).sort((a, b) => {
            return a.displayOrder - b.displayOrder
          }).forEach((customizeObj) => {
            let emptyCellNum = customizeObj.displayOrder - index
            while (emptyCellNum > 1) {
              returnValue.push(utilProduct.getCustomizeEmptyColumn())
              emptyCellNum -= 1
            }
            returnValue.push(utilProduct.getCustomizeColumn(this.product.fkus[0].skus[0], customizeObj, 'attributes', 'attribute',
              this.storePath, 'ProductDetail/productDetail/fkus[0]/skus[0]', this.parentPermissionKey))

            index = customizeObj.displayOrder
          })
        }
      } else {
      // セットの場合
        // 商品種類共通のカスタマイズ属性 & セットタブ & 表示位置：右
        this.setCustomizeProperty(returnValue, define.CUSTOMIZE_PROPERTY_KEY.PRODUCT.SET.COMMON.RIGHT)
        // 対象の商品種類のカスタマイズ属性 & セットタブ & 表示位置：右
        this.setCustomizeProperty(returnValue, define.CUSTOMIZE_PROPERTY_KEY.PRODUCT.SET.PRODUCT_TYPE.RIGHT, '{productType}', this.product.productType)
        // 対象のSKU種類のカスタマイズ属性 & セットタブ & 表示位置：右
        this.setCustomizeProperty(returnValue.e, define.CUSTOMIZE_PROPERTY_KEY.PRODUCT.SET.SKU_TYPE.RIGHT, '{skuType}', this.product.productType)
      }
      return returnValue
    },
    _tableSetList () {
      let returnValue = [
        { label: '商品/SKUコード', path: this.componentProducCode, elementType: ELEMENT_TYPE.FUNCTION, width: 200, editableId: 'code' },
        { label: '商品名', path: this.componentProductName, elementType: ELEMENT_TYPE.FUNCTION, editableId: 'name' }
      ]

      // バンドルでのみ使用する情報
      if (this.isBundle) {
        // カスタマイズ属性を設定
        if (this.customizeMaster != null &&
          this.$isFunctionShown(define.PermissionKeys.Product.Detail.BundleSet.ATTRIBUTE)) {
          this.customizeMaster.filter((element) => {
            // バンドル構成品である
            return (element.functionKey === define.CUSTOMIZE_PROPERTY_KEY.PRODUCT.BUNDLE.COMPONENT)
          }).sort((a, b) => {
            return a.displayOrder - b.displayOrder
          }).forEach((customizeObj, index) => {
            const components = _.get(this.product, 'fkus[0].skus[0].components', [])
            components.forEach((component) => {
              const targetIndex = (component.attributes || []).findIndex((attribute) => {
                return attribute.attrId === customizeObj.attributeKey
              })
              if (targetIndex < 0) {
                component.attributes.unshift({
                  attrId: customizeObj.attributeKey,
                  attrValue: utilProduct.getDefaultValue(customizeObj)
                })
              } else {
                const pushData = component.attributes[targetIndex]
                component.attributes.slice(targetIndex)
                component.attributes.unshift(pushData)
              }
            })

            const property = utilProduct.getCustomizeListColumn(customizeObj, index)
            property.editableId = 'attribute'
            property.columnKey = 'attribute'
            returnValue.push(property)
          })
        }

        returnValue = returnValue.concat(
          [
            { type: 'Number', label: '数量', path: 'qty', elementType: ELEMENT_TYPE.INPUT_NUMBER, width: 100,
              validateRule: 'required', validateAs: '数量',
              class: 'right', editableId: 'qty', columnKey: 'qty' },
            { type: 'Number', label: '売上金額（税抜）', path: 'salesAmountExTax', elementType: ELEMENT_TYPE.INPUT_NUMBER, width: 100,
              class: 'right', editableId: 'salesAmountExTax', columnKey: 'salesAmountExTax',
              funcId: define.PermissionKeys.Product.Detail.BundleSet.NET_PRICE_EX_TAX },
            { type: 'Number', label: '売上金額（税込）', path: 'salesAmountInTax', elementType: ELEMENT_TYPE.INPUT_NUMBER, width: 100,
              class: 'right', editableId: 'salesAmountInTax', columnKey: 'salesAmountInTax',
              funcId: define.PermissionKeys.Product.Detail.BundleSet.NET_PRICE_IN_TAX }
          ]
        )
      }
      returnValue = returnValue.concat(
        [
          { type: 'Slot', path: 'operation', label: '', columnKey: 'operation', width: 60, class: 'right' }
        ]
      )
      return returnValue
    },
    componentDialogTableSetList () {
      // TODO：カスタマイズさせたい
      let returnValue = [
        {
          label: '商品/SKU', properties: [
            {
              path: this.componentProducCode, elementType: ELEMENT_TYPE.FUNCTION
            }
          ]
        }, {
          label: '商品名', properties: [
            {
              path: this.componentProductName, elementType: ELEMENT_TYPE.FUNCTION
            }
          ]
        }, {
          label: 'カラー', properties: [
            {
              path: 'sku.color.name', type: 'String'
            }
          ],
          isShow: () => this.componentDialogData.sku !== null
        }, {
          label: 'サイズ', properties: [
            {
              path: 'sku.size.name', type: 'String'
            }
          ],
          isShow: () => this.componentDialogData.sku !== null
        }, {
          label: '定価', properties: [
            {
              path: 'sku.priceInTax', type: 'Number'
            }
          ],
          isShow: () => this.componentDialogData.sku !== null
        }
      ]

      return returnValue
    },
    skuSearchTableSetList () {
      // TODO：カスタマイズさせたい
      let returnValue = [
        { type: 'String', label: '商品/SKUコード', path: 'code', width: 200 },
        { type: 'String', label: '商品名', path: 'name' },
        { label: '', type: 'Slot', path: 'slots', width: 120, class: 'right', columnKey: 'detail' }
      ]

      return returnValue
    },
    activeCollapseKey () {
      return 'productDetailCollapse'
    },
    searchBundleMode () {
      return define.SEARCH_MODE.BUNDLE
    }
  },
  created () {
    this.activeCollapseName = _.split(common.getLocalStorage(this.activeCollapseKey), ',')
    customValidationRules(this)
  },
  beforeUpdate () {
    const properties = [].concat(this.bundleInfo1, this.bundleInfo2)
    const propertyArray = []
    const attributePropertyArray = []
    properties.forEach((properties) => {
      const property = properties.properties[0]
      let path = property.path || ''
      if ((typeof path === 'string' && path !== '') &&
        (properties.properties[0].funcId == null || !this.$isFunctionDisabled(properties.properties[0].funcId))) {
        const pathArray = path.split('.')
        // ドット区切りで分割して、通常項目か属性情報か判定
        // ex.
        // 通常項目：name→['name']
        // 属性情報：attributes.8.attrValue→['attributes','8','attrValue']
        if (pathArray.length > 1 && pathArray[0] === 'attributes') {
          // pathがドット区切りかつ分割した最初の要素が「attributes」→attributes
          attributePropertyArray.push(property)
        } else {
          propertyArray.push(property)
        }
      }
    })
    this.fetchProductDetailProperties({ propertyArray: propertyArray, type: 'sku' })
    this.fetchProductDetailProperties({ propertyArray: attributePropertyArray, type: 'skuAttribute' })
  },
  methods: {
    ...mapActions('ProductDetail', [
      'fetchProductDetailProperties'
    ]),
    /**
     * collapse の 開閉状態を localStorage に保存します。
     */
    collapseChange: function () {
      common.setLocalStorage(this.activeCollapseKey, this.activeCollapseName.join())
      this.activeCollapseName = common.getLocalStorage(this.activeCollapseKey).split(',')
    },
    bundleComponentDataFilter: function () {
      return this.bundleComponentData.filter((comp) => {
        return _.get(comp, 'isActive', 1) === 1
      })
    },
    componentProducCode: function (row) {
      return _.get(row, 'sku.code', _.get(row, 'product.code'))
    },
    componentProductName: function (row) {
      return _.get(row, 'sku.name', _.get(row, 'product.name'))
    },
    /**
     * Tooltipの項目を返却する.
     * @return {Array}
     */
    getTooltipList (row) {
      return [
        {
          title: '行削除',
          click: () => this.removeRow(row)
        }
      ]
    },
    onRowClick (row, event) {
      if (['operation', 'salesAmountExTax', 'salesAmountInTax', 'qty', 'attribute'].includes(event.columnKey) && [ define.MODE.EDIT, define.MODE.NEW ].includes(this.mode)) {
        // 何もしない
        return
      }

      this.showComponentDialog(row)
    },
    onDetailBtnClick (row) {
      const convertRow = {}
      convertRow.sku = row

      this.showComponentDialog(convertRow)
    },
    showComponentDialog (row) {
      this.componentDialogData = row
      this.componentItemDialogVisible = true
    },
    componentItemDialogClose () {
      this.componentItemDialogVisible = false
    },
    removeRow: function (row) {
      const deleteDataIndex = this.bundleComponentData.findIndex((component) => {
        return _.get(component, 'sku.code', 'a') === _.get(row, 'sku.code', 'b') ||
        _.get(component, 'product.code', 'a') === _.get(row, 'product.code', 'b')
      })
      if (row.id) {
        this.bundleComponentData[deleteDataIndex].isActive = 0
        this.bundleComponentData.push(this.bundleComponentData[deleteDataIndex])
        this.bundleComponentData.splice(deleteDataIndex, 1)
      } else {
        this.bundleComponentData.splice(deleteDataIndex, 1)
      }
    },
    onAddComponent (row) {
      this.searchSkusDialogVisible = true
    },
    showDetailBtn (row) {
      return row.column.columnKey === 'detail' && ('product' in row.row)
    },
    skuSelected (row) {
      const sku = this.product.fkus[0].skus[0]
      sku.components.forEach((component, index) => {
        _.set(component, 'displayOrder', index + 1)
      })

      const addComponent = {}
      addComponent.qty = 1
      addComponent.salesAmountExTax = 0
      addComponent.salesAmountInTax = 0
      addComponent.displayOrder = this.bundleComponentData.length + 1
      const attributes = []
      // カスタマイズ属性を設定
      if (this.customizeMaster != null &&
        this.$isFunctionShown(define.PermissionKeys.Product.Detail.BundleSet.ATTRIBUTE)) {
        this.customizeMaster.filter((element) => {
          // バンドル構成品である
          return (element.functionKey === define.CUSTOMIZE_PROPERTY_KEY.PRODUCT.BUNDLE.COMPONENT)
        }).sort((a, b) => {
          return a.displayOrder - b.displayOrder
        }).forEach((customizeObj) => {
          attributes.push({
            attrId: customizeObj.attributeKey,
            attrValue: utilProduct.getDefaultValue(customizeObj)
          })
        })
      }

      _.set(addComponent, 'attributes', attributes)

      if (row.product == null) {
        addComponent.product = row
        addComponent.sku = null
      } else {
        addComponent.product = null
        addComponent.sku = row
      }
      sku.components.push(addComponent)

      this.searchSkusDialogVisible = false
    },
    htmlClick (event, displayItem, displayValue) {
      this.$store.dispatch({
        type: 'set',
        states: {
          [`${this.storePath}/htmlPreviewDialogVisible`]: true,
          [`${this.storePath}/htmlPreviewDialogContent`]: displayValue
        }
      })
    },
    /**
     * 指定された機能IDのカスタマイズ属性の表示用プロパティを returnValue に設定する
     * @param {ObjectArray} returnValue 表示用プロパティオブジェクト
     * @param {String} functionKey 機能ID（カスタマイズ設定マスタの機能ID）
     * @param {String} replaceTarget 機能IDの置換対象 (例：{skuType}, {productType})
     * @param {String} replaceValue 機能IDの置換値 (例：this.product.productType)
     */
    setCustomizeProperty (returnValue, functionKey, replaceTarget = '', replaceValue = '') {
      let index = 1
      if (this.customizeMaster != null &&
        this.$isFunctionShown(define.PermissionKeys.Product.Detail.BundleSet.ATTRIBUTE)) {
        this.customizeMaster.filter((element) => {
          return (element.functionKey === functionKey.replace(replaceTarget, replaceValue))
        }).sort((a, b) => {
          return a.displayOrder - b.displayOrder
        }).forEach((customizeObj) => {
          let emptyCellNum = customizeObj.displayOrder - index
          while (emptyCellNum > 1) {
            returnValue.push(utilProduct.getCustomizeEmptyColumn())
            emptyCellNum -= 1
          }
          returnValue.push(utilProduct.getCustomizeColumn(this.product.fkus[0].skus[0], customizeObj, 'attributes', 'attribute',
            this.storePath, 'ProductDetail/productDetail/fkus[0]/skus[0]', this.parentPermissionKey))

          index = customizeObj.displayOrder
        })
      }
    }
  }
}
</script>
